import { useState } from 'react';
import _ from 'lodash';

export default function useMergeState<T extends object>(initialState: T) {
  const [state, setState] = useState(initialState);
  /**
   * Merges a partial update into the hook's state object. Assigns the patch onto the previous state and returns a fresh copy so React sees a new reference.
   *
   * @param newState - Fields to merge into the current state.
   * @returns The value returned by the underlying state setter.
   */
  const setMergedState = (newState: Partial<T>) =>
    setState((prevState) => {
      const expectedState = _.assign(prevState, newState);
      return { ...expectedState };
    });
  return [state, setMergedState] as const;
}
